import styled, { css, DefaultTheme, StyledComponent } from 'styled-components';

import Sticker, { StickerProps } from 'design-system/components/Sticker';

export interface BadgeProps {
  variant?: 'alert' | 'active' | 'basic';
}

const Badge = styled(({ variant, ...rest }: BadgeProps) => {
  let variantProp: StickerProps['variant'];
  switch (variant) {
    case 'alert':
      variantProp = 'danger';
      break;
    case 'active':
      variantProp = 'purple';
      break;
    case 'basic':
    default:
      variantProp = 'grey';
  }

  return <Sticker {...rest} variant={variantProp} />;
})<BadgeProps>(
  () => css`
    line-height: 16px;
    min-width: 16px;
    height: 16px;
    text-align: center;
    border-radius: 100px;
    font-size: 10px;
  `,
) as StyledComponent<'span', DefaultTheme, BadgeProps, never>;
/**
 * The type workaround above makes the correct types available for Badge.
 * Having duplicate prop names between Badge and Sticker seems to cause some oddities.
 *
 * We insist on making this a styled component so the component itself can be targeted in styles.
 * See: https://styled-components.com/docs/advanced#referring-to-other-components
 */

export default Badge;
